<template>
  <page-header-wrapper>
    <div slot="extra">
      <router-link v-action:add :to="{ path: '/settings/employee/form' }">
        <a-button type="primary" icon="plus">新建成员</a-button>
      </router-link>
    </div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="inline">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.name"
              placeholder="请输入姓名"
              enter-button
              @search="getLists()"
            />
          </div>
        </standard-form-row>
      </a-form>
    </a-card>

    <div class="ant-pro-pages-list-projects-cardList">
      <div slot="operate" class="change-state">
        <a-radio-group @change="searchChangeState">
          <a-radio-button value="0">全部</a-radio-button>
          <a-radio-button value="1">展示</a-radio-button>
          <a-radio-button value="2">隐藏</a-radio-button>
        </a-radio-group>
      </div>
      <a-list
        :loading="loading"
        :data-source="list"
        :grid="{ gutter: 24, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }"
        :pagination="pagination"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="ant-pro-pages-list-projects-card" hoverable>
            <viewer slot="cover" class="cover-pic">
              <img :src="globalUrl + item.avatar" :key="item.name" />
            </viewer>
            <a-card-meta :title="item.name">
              <template slot="description">
                <ellipsis :length="50" style="margin-bottom: 1rem">{{ item.desc }}</ellipsis>
              </template>
            </a-card-meta>
            <div class="cardItemContent">
              <p>
                <a-tag v-for="(lable, key) in (item.title || '').split(',')" :key="key">
                  {{ lable }}
                </a-tag>
              </p>
              <span>上次修改：{{ moment(item.updated_at).fromNow() }}</span>
            </div>
            <template slot="actions">
              <a-tooltip title="编辑" v-action:update>
                <router-link v-action:update :to="'/settings/employee/form/' + item.id">
                  <a-icon type="edit" />
                </router-link>
              </a-tooltip>

              <a-tooltip title="删除" v-action:delete>
                <a-popconfirm
                  title="确定要删除该成员吗？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="handleOnDelete(item.id)"
                >
                  <a-icon type="delete" />
                </a-popconfirm>
              </a-tooltip>
              <a-tooltip title="修改状态" v-action:state>
                <a-switch :checked="item.state === 1" @change="handleChangeState(item.id)">
                  <a-icon slot="checkedChildren" type="check" />
                  <a-icon slot="unCheckedChildren" type="close" />
                </a-switch>
              </a-tooltip>
            </template>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
  </page-header-wrapper>
</template>

<script>
import { list, card, select } from '@/mixins' // 引入
import { TagSelect, StandardFormRow, Ellipsis, AvatarList } from '@/components'
const AvatarListItem = AvatarList.AvatarItem
const apiList = {
    getList: '/settings/employee',
    delete: '/settings/employee/',
    changeState: '/settings/employee/'

}
export default {
    name: 'ATPList',
    mixins: [list, card, select], // 使用mixins
    components: {
        AvatarList,
        AvatarListItem,
        Ellipsis,
        TagSelect,
        StandardFormRow
    },
    data () {
        return {
            apiList,
            params: {
                where: {
                }
            },
            typeLoad: false
        }
    },
    mounted () {
        this.getLists() // 获取广告位列表
    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.ant-pro-pages-list-projects-cardList {
    margin-top: 1rem;
}
</style>
